import React from 'react';
import './AndroidPWAInstallManual.css';

export default function AndroidPWAInstallManual({ onClose }) {
  return (
    <div className="android-install-backdrop" role="dialog" aria-modal="true">
      <div className="android-install-card">
        <button className="android-install-close" onClick={onClose} aria-label="Close">×</button>
        
        <div className="android-install-header">
          <h2>Install App</h2>
          <p>Add this app to your home screen for the best experience</p>
        </div>

        <div className="android-install-steps">
          <div className="android-install-step">
            <div className="android-step-number">1</div>
            <div className="android-step-content">
              <div className="android-step-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              </div>
              <div className="android-step-text">
                <strong>Open Chrome menu</strong>
                <span>Tap the three dots (⋮) in the top right corner</span>
              </div>
            </div>
          </div>

          <div className="android-install-step">
            <div className="android-step-number">2</div>
            <div className="android-step-content">
              <div className="android-step-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                </svg>
              </div>
              <div className="android-step-text">
                <strong>Add to Home screen</strong>
                <span>Look for "Add to Home screen" or "Install app" option</span>
              </div>
            </div>
          </div>

          <div className="android-install-step">
            <div className="android-step-number">3</div>
            <div className="android-step-content">
              <div className="android-step-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/>
                </svg>
              </div>
              <div className="android-step-text">
                <strong>Confirm installation</strong>
                <span>Tap "Add" or "Install" to complete the process</span>
              </div>
            </div>
          </div>
        </div>

        <div className="android-install-alternative">
          <h3>Alternative method:</h3>
          <p>If you don't see the install option, try refreshing the page or visiting again later. Some browsers need a few visits before showing the install prompt.</p>
        </div>

        <div className="android-install-benefits">
          <h3>Why install?</h3>
          <ul>
            <li>✨ Get 21 free AI requests</li>
            <li>🚀 Faster loading times</li>
            <li>📱 Works offline</li>
            <li>🎯 Easy access from home screen</li>
          </ul>
        </div>
      </div>
    </div>
  );
} 